"use client";

import { Quote } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
export default function Testimonials() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const testimonials = [{
    quote: "The NoMoCo Pillow has significantly improved patient positioning during imaging. It provides the stability we need for high-quality diagnostic results.",
    name: "Dr. Sarah Jenkins",
    role: "Radiology Director, City Medical Center"
  }, {
    quote: "Implementing the NoMoCo system was seamless. Our technicians appreciate the ease of use, and the durability of the materials is exceptional for clinical environments.",
    name: "Mark Thompson",
    role: "Lead Technologist, University Imaging"
  }, {
    quote: "Patient comfort is our priority. The NoMoCo support system allows for precise alignment without compromising the patient's experience during long procedures.",
    name: "Elena Rodriguez",
    role: "Clinical Manager, Regional Hospital"
  }, {
    quote: "A vital tool for our research imaging department. The consistency in positioning has reduced our retake rates and improved overall workflow efficiency.",
    name: "Dr. Alan Chen",
    role: "Research Lead, Medical Institute"
  }];
  return <section data-section-id="14383" id="researchtestimonials" className="bg-background border-b-2 border-border ![padding:0px_0px_144px_0px]">
      <div className="mx-auto max-w-[1320px] px-5 md:px-8">
        {}
        <div ref={headerRef} className={`grid grid-cols-12 gap-6 mb-16 md:mb-20 transition-all duration-500 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <div className="col-span-12 md:col-span-8">
            <div className="font-default text-xs font-semibold uppercase tracking-[0.14em] text-primary mb-6">
              {"// CLINICAL FEEDBACK"}
            </div>
            <h2 className="font-default font-extrabold text-foreground leading-[0.96] tracking-[-0.03em] text-[clamp(2.25rem,4.5vw,4rem)]">
              Trusted by professionals.
            </h2>
          </div>
          <div className="hidden md:block md:col-span-4" aria-hidden="true" />
        </div>

        {}
        <div ref={gridRef} className={`transition-all duration-500 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
          <Carousel className="w-full max-w-4xl mx-auto" opts={{
          align: "start",
          loop: true
        }}>
            <CarouselContent>
              {testimonials.map((item, i) => <CarouselItem key={i} data-index={i}>
                  <div className="flex flex-col items-center text-center px-4 md:px-12 py-8">
                    <div className="mb-8">
                      <Quote className="text-primary/40" strokeWidth={2} style={{
                    width: "3.5rem",
                    height: "3.5rem"
                  }} aria-hidden="true" />
                    </div>

                    <blockquote className="font-default text-foreground text-xl md:text-3xl font-medium leading-[1.4] tracking-tight mb-10 italic">
                      "{item.quote}"
                    </blockquote>

                    <div className="flex flex-col items-center">
                      <div className="h-1 w-12 bg-primary mb-6 rounded-lg" />
                      <cite className="not-italic">
                        <span className="block font-default text-foreground font-bold text-lg md:text-xl">
                          {item.name}
                        </span>
                        <span className="block font-default text-muted-foreground text-sm md:text-base mt-1 uppercase tracking-wider">
                          {item.role}
                        </span>
                      </cite>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            <div className="hidden md:block">
              <CarouselPrevious className="left-[-3rem] border-2 border-border hover:bg-accent hover:text-primary transition-colors rounded-lg shadow-md" />
              <CarouselNext className="right-[-3rem] border-2 border-border hover:bg-accent hover:text-primary transition-colors rounded-lg shadow-md" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}